import publicCta from '../content/publicCta.json';
import { getWhatsAppUrl } from '../constants/whatsappContact.js';

/** URL de WhatsApp del convenio: link personalizado o mensaje por defecto. */
export function getConvenioWhatsAppHref(convenio) {
  const link = String(convenio?.link_whatsapp || '').trim();
  if (link) {
    if (/^https?:\/\//i.test(link)) return link;
    if (/^wa\.me\//i.test(link)) return `https://${link}`;
    return link.startsWith('http') ? link : `https://${link}`;
  }
  const topic = publicCta.whatsappTopics?.find((t) => t.id === 'convenios');
  const base = topic?.message || 'Hola, quiero más información sobre convenios.';
  const nombre = String(convenio?.nombre || '').trim();
  const message = nombre ? `${base} (${nombre}).` : base;
  return getWhatsAppUrl(message);
}
